"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormControl = void 0;
var _CatchFromControlContext = _interopRequireDefault(require("./CatchFromControlContext"));
var _material = require("@mui/material");
var _react = require("react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useFormControl = exports.useFormControl = function useFormControl() {
  var fromControl = (0, _material.useFormControl)();
  var caughtFormControl = (0, _react.useContext)(_CatchFromControlContext["default"]).fromControl;
  return caughtFormControl !== null && caughtFormControl !== void 0 ? caughtFormControl : fromControl;
};